export const DEALER_PASSPORT_USER = [
  [
    "id",
    "DealerName",
    "legalDealerName",
    "tradeDealerName",
    "OrganizationalLegalForm",
    "category",
    "newDealer",
    "Main",
    "headCompanyId",
    "status",
    "code",
    "successorId",
    "entfCode",
    "entfSuccessorNo",
    "entfSuccessorCode",
    "successorCode",
    "KPP",
    "OGRN",
    "INN",
    "birCode",
  ],
  [
    "reestrAddress",
    "address",
    "zipCode",
    "country",
    "FO",
    "subject",
    "district",
    "city",
    "street",
    "house",
    // "street_house",
  ],
  [
    "reestrLegalAddress",
    "legalAddress",
    "legalZipCode",
    "legalCountry",
    "LegalFO",
    "legalSubject",
    "legalDistrict",
    "legalCity",
    "legalStreet",
    "legalHouse",
  ],
  [
    "reestrPostAddress",
    "postalAddress",
    "postalZipCode",
    "postalCountry",
    "postalFO",
    "postalSubject",
    "postalDistrict",
    "postalCity",
    "postalStreet",
    "postalHouse",
  ],
  [
    "consumerCode",
    "corporateEmail",
    "EGR_Date",
    "EGR_Series",
    "EGR_Number",
    "hideOnLadaRu",
    "terminated",
    "extendedForNextYear",
    "protocolOfConclusion",
    "protocolOfTermination",
    "temporaryDecision",
    "DealerLADASERV",
    "protocolOfIntentions",
    "bankName",
    "BIK",
    "correspondentAccount",
    "settlementAccount",
    "regionCode",
    "ent_id",
    "updatedAt",
    "headCode",
    "headFax",
    "headNameImported",
    "headNameGenitive",
    "headPositionImported",
    "headPositionGenitive",
    "headPhoneImported",
    "headEmailImported",
    "termOfAuthority",
  ],
  [
    "X_SHOP_FLAG",
    "X_STO_PHCODE",
    "X_STO_PHONE",
    "X_STO_EMAIL",
    "X_SHOP_PHCODE",
    "X_SHOP_PHONE",
    "X_SHOP_EMAIL",
    "X_SHOP_NAME",
  ],
  ["stoEmail", "stoPhCode", "stoPhone", "shopPhCode", "shopPhone", "shopEmail"],
  ["KGA_CODE", "ONEC_CODE"],
];
export const DEALER_PASSPORT_USER_EDIT = [
  ["ownerName", "ownerPhone", "ownerMobilePhone", "ownerEmail"],
  [
    "headName",
    "headPhone",
    "headMobilePhone",
    "headEmail",
    "EP",
    "beginWorkingDate",
    "IS_Id",
  ],
  [
    "accountantName",
    "accountantCode",
    "accountantPhone",
    "accountantFax",
    "accountantEmail",
  ],
  [
    "responsibleForLadaName",
    "responsibleForLadaCode",
    "responsibleForLadaPhone",
    "responsibleForLadaFax",
    "responsibleForLadaEmail",
  ],
];
export const DEALER_PASSPORT_USER_NO_EDIT = [
  "EP",

  "IS_Id",
  "EP",
  "beginWorkingDate",
  "terminated",
  "extendedForNextYear",
  "protocolOfConclusion",
  "protocolOfTermination",
  "DealerLADASERV",
  // "accountantName",
  // "accountantCode",
  // "accountantPhone",
  // "accountantFax",
  // "accountantEmail",
  // "responsibleForLadaName",
  // "responsibleForLadaCode",
  // "responsibleForLadaPhone",
  // "responsibleForLadaFax",
  // "responsibleForLadaEmail",
  "bankName",
  "BIK",
  "correspondentAccount",
  "settlementAccount",
  "regionCode",
  "temporaryDecision",
  "newDealer",
  "Main",
  "successorId",
  "entfCode",
  "entfSuccessorNo",
  "entfSuccessorCode",
  "corporateEmail",
  "protocolOfIntentions",
  "consumerCode",
  "tradeDealerName",
  "termOfAuthority",
  "ent_id",
];

export const DEALER_PASSPORT_USER_EDIT_OWNER = [
  "ownerName",
  "ownerPhone",
  "ownerMobilePhone",
  "ownerEmail",
];
export const DEALER_PASSPORT_USER_EDIT_HEAD = [
  "headName",
  "headPhone",
  "headMobilePhone",
  "headEmail",
];
export const DEALER_PASSPORT_USER_EDIT_ACCOUNTANT = [
  // "accountantEmail",
  // "accountantFax",
  // "accountantPhone",
  // "accountantCode",
  // "accountantName",
];
export const DEALER_PASSPORT_USER_EDIT_LADA = [
  // "responsibleForLadaName",
  // "responsibleForLadaCode",
  // "responsibleForLadaPhone",
  // "responsibleForLadaFax",
  // "responsibleForLadaEmail",
];
export const DEALER_PASSPORT_OPTION_STATUS = ["active", "candidate", "inactive"];
export const DEALER_PASSPORT_PROJECT_FILE = [
  "name",
  "createdAt",
  "status",
  "Link",
];
export const DEALER_PASSPORT_IVIDEON_AUTHORIZATED = [
  { label: "Да", value: "true" },
  { label: "Нет", value: "false" },
];
export const DEALER_PASSPORT_IVIDEON_GROUPCHECKSTATUS = [
  { label: "Да", value: "true" },
  { label: "Нет", value: "false" },
];
export const SERVICE_CHECK_IVIDEON = [
  { label: "Проверен", value: "true" },
  { label: "Не проверен", value: "false" },
];
export const SALE_CHECK_IVIDEON = [
  { label: "Проверен", value: "true" },
  { label: "Не проверен", value: "false" },
];
export const CHECK_STATUS_IVIDEON = [
  { label: "Проверен", value: "true" },
  { label: "Не проверен", value: "false" },
];

export const FILTER_EMPLOYEE = {
  ids: undefined,
  code: undefined,
  dealerName: undefined,
  address: undefined,
  city: undefined,
  category: undefined,
  checkStatus: undefined,
  serviceCameras: undefined,
  saleCameras: undefined,
  serviceAccept: undefined,
  saleAccept: undefined,
  ivideonAuthorized: undefined,
  status: undefined,
  extendedForNextYear: undefined,
};

export const DEALER_STATUS_OPTIONS = [
  { label: "Активный", value: "active" },
  { label: "Неактивный", value: "inactive" },
];

export const EXTENDED_FOR_NEXT_YEAR_OPTIONS = [
  { label: "Да", value: "true" },
  { label: "Нет", value: "false" },
];
